import React from 'react';
import { Select } from 'antd';

import { Option } from '../fleet-rule-utils';

import styles from '../fleet-rule.module.scss';

import { Tooltip } from 'components';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

const { Option: SelectOption } = Select;

export interface FleetDropdownTypeProps {
	disabled?: boolean;
	handleChange: (e) => void;
	value: string;
	options: Option[];
	title: string;
	tooltipText: string;
}

export const FleetDropdownType = ({
	handleChange,
	value,
	options,
	disabled = false,
	title,
	tooltipText
}: FleetDropdownTypeProps) => (
	<div data-test-id="fleet-router-rule-body-right-side-dropdown" className={styles['dropdown-type']}>
		<div className={styles['dropdown-type-title']}>
			<div>{title}</div>
			<Tooltip placement="top" title={tooltipText}>
				<span className={styles['info-button']}>
					<BringgIcon iconName={BringgFontIcons.Info} />
				</span>
			</Tooltip>
		</div>
		<Select onChange={handleChange} value={value} disabled={disabled} className={styles['dropdown-type-main']}>
			{options.map(option => (
				<SelectOption className={styles['dropdown-type-item']} key={option.key} value={option.value}>
					{option.key}
				</SelectOption>
			))}
		</Select>
	</div>
);
